import { isInternalEmail } from '@repo/utils-internal-user'

// STU-10453: paypaltest@ is a company-domain review account, not staff. It must
// not get admin UI (video kebab, Flow, isAdminGuard routes, etc.).
const NON_EMPLOYEE_CF_EMAILS = new Set(['paypaltest@creativefabrica.com'])

export function isCreativeFabricaEmail(email?: string): boolean {
  if (!email) {
    return false
  }

  const normalized = email.toLowerCase()
  if (NON_EMPLOYEE_CF_EMAILS.has(normalized)) {
    return false
  }

  return isInternalEmail(normalized)
}
